import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import activeGameReducer from './ActiveGameSlice';
import appUiReducer from './AppUiSlice';
import sqFormReducer from './SqFormSlice';
import sqModalReducer from './SqModalSlice';
import sqScheduleReducer from './SqScheduleSlice';
import squaresReducer from './SquaresSlice';
import sqUserReducer from './SqUserSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [''],
};

const uiReducers = combineReducers({ app: appUiReducer, modal: sqModalReducer });
// const playReducers = combineReducers({ sq: squaresReducer, activegame: activeGameReducer });
/**
 * ui: uiReducer,
 * ranking: rankReducer,
 * stats: rankReducer,
 * schedule: scheduleReducer,
 * games: gamesReducer,
 * byeweek: byeWeekReducer,
 * league: teamsReducer,
 */

export const rootReducer = combineReducers({
  sq: squaresReducer,
  activegame: activeGameReducer,
  users: sqUserReducer,
  ui: uiReducers,
  sqform: sqFormReducer,
  schedule: sqScheduleReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// export const store = setupStore(persistedReducer);
export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
// export type AppStore = ReturnType<typeof setupStore>;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
